import React from 'react';

import './Checkbox.scss';
import TooltipWrapper from "../../visuals/tooltip/Tooltip.wrapper";
import {CheckLog} from "../../services/interactions/elements/checkbox";

function Checkbox({label, bool, onChange, vertical, tooltip, disabled}){
    const handleChange = () => {
        if (disabled) {
            return;
        }
        onChange(!bool);
    }
    return (
        <div className={`CheckboxComponent ${vertical ? '_vertical' : ''} ${disabled ? '_disabled' : ''}`}>
            <div className="_inputContain">
                {
                    vertical?
                        <>
                            {label && tooltip ?
                                <TooltipWrapper label={tooltip} value={''}>
                                    <p>{label}</p>
                                </TooltipWrapper> : <>
                                    {label ? <p>{label}</p> : ''}
                                </>
                            }
                            <div className={`checkbox ${bool ? 'enabled' : 'disabled'}`} onClick={handleChange}>
                                <span className="material-icons">
                                    check
                                </span>
                            </div>
                        </> : <>
                            <div className={`checkbox ${bool ? 'enabled' : 'disabled'}`} onClick={handleChange}>
                                <span className="material-icons">
                                    check
                                </span>
                            </div>
                            {label ? <p>{label}</p> : ''}
                        </>
                }
            </div>
        </div>
    )
}

export default CheckLog(Checkbox);
